var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.isOpen)?_c('div',{staticClass:"sidemenu-wrapper"},[_c('SideMenu',{attrs:{"isWhite":_vm.isWhite},on:{"close":_vm.close}})],1):_vm._e()]),_vm._v(" "),(!_vm.isOpen)?_c('div',{on:{"click":_vm.open}},[_c('Hamburger',{attrs:{"isWhite":_vm.isWhite}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f54876","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Menu.vue
// module id = null
// module chunks = 